import React from "react";
import { useCallback, useEffect, useState } from "react";
import { NavLink, useLocation, useSearchParams, NavLinkProps } from "react-router-dom";
import { projectKey } from "utils/utils";

interface CustomNavLinkProps extends Omit<NavLinkProps, "to"> {
    page: string;
    view?: string;
}

export default function CustomNavLink({ page, view, children }: CustomNavLinkProps) {
    const [searchParams] = useSearchParams();
    const [active, setActive] = useState(false);
    const location = useLocation();
    useEffect(() => {
        const pg = location.pathname.split("/");
        if (pg.length > 1) {
            setActive(pg[1] === page);
        }
    }, [location.pathname, page]);
    const searchQuery = useCallback(() => {
        const s = searchParams.get(projectKey);
        if (s && active) {
            return `/?${projectKey}=${s}`;
        }
        return "";
    }, [active, searchParams]);
    return (
        <>
            {active ? (
                <span className="bp3-tab no-style-link active-link">{children}</span>
            ) : (
                <NavLink className="bp3-tab no-style-link" to={`/${page}${view ? "/" + view : ""}${searchQuery()}`}>
                    {children}
                </NavLink>
            )}
            {/* <NavLink
                className={active ? "bp3-tab no-style-link active-link" : "bp3-tab no-style-link"}
                to={`/${page}${view ? "/" + view : ""}${searchQuery()}`}
            >
                {children}
            </NavLink> */}
        </>
    );
}
